export var AuthBroadcastEvent;
(function (AuthBroadcastEvent) {
    AuthBroadcastEvent["AUTH_SUCCESS"] = "auth-success";
    AuthBroadcastEvent["AUTH_ERROR"] = "auth-error";
})(AuthBroadcastEvent || (AuthBroadcastEvent = {}));
export const AUTH_BROADCAST_CHANNEL = 'AUTH_BROADCAST_CHANNEL';
export const getAuthBroadcastChannel = () => {
    return new BroadcastChannel(AUTH_BROADCAST_CHANNEL);
};
